<template>
    
    <div  class="form-inline pb-2">
        <div class="form-group">
            <label class="form-label mr-2"
                   :for="'statuses'">
                Available statuses
            </label>
            <b-form-select v-model="selectedStatus" :options="statuses" size="sm" class="mr-2">
                <template slot="first">
                    <option :value="null" disabled>-- Please select an option --</option>
                </template>
            </b-form-select>
        </div>
        <transition name="fade">
            <div  v-if="selectedStatus && selectedStatus.declined == true" class="form-group">
                <label class="form-label mr-2"
                       :for="'reasons'">
                    Declination reasons
                </label>
                <b-form-select v-model="selectedReason" :options="reasons" size="sm" class="mr-2">
                    <template slot="first">
                        <option :value="null" disabled>-- Please select an option --</option>
                    </template>
                </b-form-select>
            </div>
        </transition>
        <button type="button"
                class="btn btn-sm btn-primary"
                @click="handleUpdateSelectedClick()">
            {{button_text}}
        </button>
    </div>

</template>

<script>
export default {
  name: 'SelectStatus',
  props: {
    statuses: Array,
    reasons: Array,
    value: Object,
    button_text: String
  },
  data: () => {
    return {
        selectedStatus: null,
        selectedReason: null
    }
  },
  mounted() {
      
  },
  watch: {

  },
  computed: {
      
  },
  methods: {
      handleUpdateSelectedClick() {
          this.$emit("button-click", { status: this.selectedStatus, reason: this.selectedReason })
      }
  }
}
</script>
